import { EmptyComponent } from "../common/EmptyComponent";
import Loadable from "react-loadable";

export const MainViewApp = Loadable({
  loader: () =>
    import(/* webpackChunkName: "container/main-view-app" */ "./MainViewApp"),
  loading: EmptyComponent
});
